module.exports = __webpack_public_path__ + "static/img/service3.5381437e.png";